jQuery(function($){
	const scheduleTableId = 'event-schedule-table-drag';
	if($('#' + scheduleTableId).length && $('.field.html').length) {
		renumberRowFields();

		Sortable.create(document.getElementById(scheduleTableId), {
			handle: '.drag > :not(.remove-row)',
			animation: 200,
			onUpdate: function() {
				renumberRowFields();
			}
		});

		function renumberRowFields() {
			const scheduleTable = $('#' + scheduleTableId);
			const fieldRows = scheduleTable.find('.event-schedule-row');
			
			let rowNumber = 0;
			fieldRows.each(function(){
				$(this).attr('row-number', rowNumber);
				rowFields = $(this).find('[name*="sc-fields["]');
				rowFields.each(function(){
					const currentName = $(this).attr('name');
					let newName = $(this).attr('name');

					// Case 1: sc-fields[NUMBER][field]
					if (currentName.match(/^sc-fields\[\d+\]\[/)) {
						newName = currentName.replace(
							/^sc-fields\[\d+\]/,
							`sc-fields[${rowNumber}]`
						);
					}
					// Case 2: sc-fields[field]
					else if (currentName.match(/^sc-fields\[[^\]]+\]/)) {
						newName = currentName.replace(
							/^sc-fields/,
							`sc-fields[${rowNumber}]`
						);
					}

					$(this).attr('name', newName);
				});
				rowNumber++;
			});

			saveSchedule();
		}
	
		$('#' + scheduleTableId).on('change', '.field.typeahead [name*="sc-fields["], .field.timepicker [name*="sc-fields["], .field.select [name*="sc-fields["]', function(){
			saveSchedule();
		});

		let keyupTimeout = null;
		$('#' + scheduleTableId).on('keyup', '.field.text [name*="sc-fields["], .field.textarea [name*="sc-fields["]', function(){
			clearTimeout(keyupTimeout);

			keyupTimeout = setTimeout(function() {
				saveSchedule();
			}, 500);
		});

		function saveSchedule() {
			const allFormFields = $('#event-schedule-table').find('[name*="sc-fields["]');
			
			let allFormValues = {};
			allFormFields.each(function(){
				allFormValues[$(this).attr('name')] = $(this).val();
			});

			const data = {
				action: 'choralorg_schedule_update_record',
				post_id: $('#event-id').val(),
				values: allFormValues,
			};

			const ajaxField = $('#event-schedule-table').closest('.field:has(.ajax-saved)');
			$(document).trigger('scfe-ajax-saving-start', {el: ajaxField});

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
				const responseJson = JSON.parse(response);
				console.log(responseJson);
	
				$(document).trigger('scfe-ajax-saving-complete', {el: ajaxField});
			});
		}

		$('#event-schedule-table-add-row').on('click', function(){
			const data = {
				action: 'choralorg_schedule_add_row',
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
				const responseJson = JSON.parse(response);
				console.log(responseJson);
	
				$('#event-schedule-table-drag').append(responseJson.html);
				renumberRowFields();
			});
		});

		$('.remove-row').on('click', function(){
			console.log('clicked');

			if(!confirm('Are you sure you want to remove this row?')) return;

			parentRow = $(this).closest('.event-schedule-row');
			parentRow.remove();
			
			renumberRowFields();
		});

		$('#visible-to-members input[type="checkbox"]').on('change', function(){
			const data = {
				action: 'choralorg_schedule_update_visibility',
				event_id: $('#event-id').val(),
				value: this.checked,
			};

			console.log(data);

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
				const responseJson = JSON.parse(response);
				console.log(responseJson);
			});
		});
	}
});